import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { initMobile } from "@/utils/capacitor";
import { initErrorCapture } from "@/utils/errorCapture";

// Initialize mobile features when running on native platforms
initMobile();

// Capture frontend errors and send to backend
initErrorCapture();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
